import { isReArchBonusEnabled } from 'access/utils';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import useReduxSelector from 'utils/useReduxSelector';
import { FeatureFlags } from 'types';

export const useReArchBonusEnabled = (): boolean => {
  const featureFlags = useReduxSelector(loggedInUserSelectors.features);
  return isReArchBonusEnabled(featureFlags as Record<FeatureFlags, boolean> | null);
};
